import { frontendURL } from '../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
  CONTACT_PERMISSIONS,
  PORTAL_PERMISSIONS,
  WEB_ORDER_ACCESS_PERMISSIONS,
  WEB_ORDER_CUSTOMER_ACCESS_PERMISSIONS,
  WEB_ORDER_PRODUCT_ACCESS_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import SearchView from './components/SearchView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/search/:tab?'),
    name: 'search',
    meta: {
      permissions: [
        ...ROLES,
        ...CONVERSATION_PERMISSIONS,
        CONTACT_PERMISSIONS,
        PORTAL_PERMISSIONS,
        ...WEB_ORDER_ACCESS_PERMISSIONS,
        ...WEB_ORDER_CUSTOMER_ACCESS_PERMISSIONS,
        ...WEB_ORDER_PRODUCT_ACCESS_PERMISSIONS,
      ],
    },
    component: SearchView,
  },
];
